import React from "react";
import Header from "../components/Header/Header";
import Navbar from "../components/Navbar/Navbar";
import Committee from "../components/Committee/Committee";
import avatar from "../components/assets/avatar.png";
import dipankar from "../components/assets/dipankar.png";
import uma from "../components/assets/uma.png";
import dil from "../components/assets/dil.png";
import ambak from "../components/assets/ambak.jpeg";
import amit  from "../components/assets/amit.png";
const ScientificAdvisoryCommittee = () => {
  const committeeMembers = [
    {
      name: "Prof. Amit Awasthi",
      role: "President, I.I.S.",
      imageUrl: amit,
    },
    {
      name: "Dr. Uma Kanga",
      designation: "Additional Professor, Department of T.I.I., All India Institute of Medical Sciences, New Delhi",
      role: "Convenor [Immunocon-2023]",
      imageUrl: uma,
    },
    {
      name: "Dr. Dipankar Nandi",
      designation:"Department of Biochemistry, Indian Institute of Sciences Bangalore",
      role: "Convenor [Immunocon-2024]",
      imageUrl: dipankar,
    },
    {
      name: "Dr. Ambak K. Rai",
      designation: "Associate Professor, MNNIT Allahabad",
      role: "Convenor [Immunocon-2025]",
      imageUrl: ambak,
    },
    {
      name: "Dr. Dil Afroz",
      designation:"Professor, Advanced Center for Human Genetics Immunology & Molecular Medicine, Sher-i-Kashmir Institute of Medical Sciences, Srinagar",
      role: "Convenor, Immunocon-2026 [Proposed]",
      imageUrl:dil,
    },
  ];

  return (
    <>
      <Header />
      <Navbar />
      <Committee heading="Scientific Program Advisory Committee" people={committeeMembers} />
    </>
  );
};

export default ScientificAdvisoryCommittee;
